<template>
  <div>
     <ServerError v-if="ServerError"/>
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center >
      <v-flex lg10 class="fontts">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout wrap justify-center>
            <v-flex align-self-center text-center lg1 md1 sm1 xs3 pt-lg-5 pl-lg-5>
              <v-img
                :src="require('../../assets/kurma-logo.png')"
                contain
                width="80px"
                height="80px"
              ></v-img>
            </v-flex>
            <v-flex py-lg-5 py-4  lg12 md11 xs12 align-self-center text-center >
              <span class="fontbold">Add personal information</span>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex align-self-center lg5 md5 xs12 pl-md-3 pl-lg-0 pl-sm-3>
              <v-text-field
                outlined
                dense
                v-model="name"
                counter
                type="text"
                :rules="nameRules"
                label="Full Name"
                required
                prepend-inner-icon="mdi-account-circle"
              ></v-text-field>

              <v-select
                outlined
                dense
                v-model="genders"
                :items="gender"
                :rules="[(v) => !!v || 'Field is required']"
                label="Gender"
                required
                prepend-inner-icon="mdi-account"
              ></v-select>

              <v-text-field
                outlined
                dense
                v-model="email"
                :rules="[rules.required, rules.email]"
                label="E-mail"
                required
                prepend-inner-icon="mdi-email"
              ></v-text-field>

              <v-text-field
                outlined
                dense
                v-model="uname"
                :rules="[rules.required]"
                label="Username"
                required
                prepend-inner-icon="mdi-keyboard"
              ></v-text-field>

              <v-text-field
                outlined
                dense
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[passwordRules.required, passwordRules.min]"
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                name="input-10-2"
                label="Password"
                hint="At least 8 characters"
                class="input-group--focused"
                @click:append="showPassword = !showPassword"
                prepend-inner-icon="mdi-lock"
              ></v-text-field>

             
              <!-- 
              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="validate"
              >
                Validate
              </v-btn>

              <v-btn color="error" class="mr-4" @click="reset">
                Reset Form
              </v-btn>

              <v-btn color="warning" @click="resetValidation">
                Reset Validation
              </v-btn> -->
            </v-flex>

            <v-flex lg1><v-spacer></v-spacer></v-flex>

            <v-flex align-self-start lg5 pr-md-3 pr-lg-0 pr-sm-3>
              <v-text-field
                outlined
                dense
                v-model="organisation"
                type="string"
                :rules="[rules.required]"
                maxlength="60"
                label="Organisation"
                required
                prepend-inner-icon="mdi-account-supervisor-circle"
              ></v-text-field>

              <v-select
                outlined
                dense
                v-model="occupations"
                :items="occupation"
                :rules="[(v) => !!v || 'Field is required']"
                label="Occupation"
                required
                prepend-inner-icon="mdi-briefcase"
              ></v-select>

              <v-text-field
                outlined
                dense
                v-model="phno"
                :rules="phnoRules"
                counter
                maxlength="10"
                label="Phone"
                required
                prepend-inner-icon="mdi-cellphone-android"
              ></v-text-field>

              <v-select
                outlined
                dense
                v-model="state"
                :items="states"
                :rules="stateRules"
                label="State"
                placeholder="Kerala"
                required
                prepend-inner-icon="mdi-map-marker"
              ></v-select>
            </v-flex>
          </v-layout>
           <v-layout wrap justify-center text-center>
              <v-felx lg7 md12 class="fontts" >
                 <v-checkbox
                v-model="checkbox"
                :rules="[(v) => !!v || 'You must agree to continue!']"
                label="I accept the terms and conditions"
                required
              ></v-checkbox>

              <v-btn
                :disabled="!valid"
                color="success"
                width="70%"
                @click="register"
              >
                Create Account
              </v-btn>

              <v-layout wrap justify-center>
                <v-flex pb-12 align-self-center py-4>
                  <span
                    >Already have an account!
                    <router-link class="routerlink" to="/login"
                      ><span class="fontgreen">Login</span></router-link
                    ></span
                  >
                </v-flex>
              </v-layout>

              </v-felx>
            </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    ServerError:false,
    userData: [],
    layout: "one",
    valid: true,
    name: "",

    showPassword: false,
    password: "",
    passwordRules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 8 || "Min 8 characters",
    },
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v.length >=3 && v.length <= 10 ) || "Name must be less than 10 characters",
    ],
     stateRules: [
      (v) => !!v || "state is required",

    ],
    
    email: "",
    // emailRules: [
    //   (v) => !!v || "E-mail is required",
    //   (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    // ],
    rules: {
      required: (value) => !!value || "Required.",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
    phno: "",
    phnoRules: [
      (v) => !!v || "Phone is required",
      (v) =>
        /[6-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/.test(v) ||
        "Phone is invalid",
    ],
    showsnackbar: false,
    msg: null,
    uname: "",
    organisation: null,
    lat:'10.850516',
    lon:'76.27108',
    state: null,
    select: null,
    genders: null,
    occupations: null,
    occupation: ["Student", "Graduate", "Professional", "Retired", "Others"],
    gender: ["Male", "Female", "Others"],
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
    states: ["Andhra Pradesh","Arunachal Pradesh ","Assam","Bihar","Chhattisgarh","Haryana","Himachal Pradesh","Jammu and Kashmir",
    "Jharkhand","Karnataka","Kerala","Madya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha",
    "Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","UttaraKhand",
    "West Bengal"],
  }),

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    register() {
      if (this.$refs.form.validate() && this.checkbox == true) {
        // var body = {};
        // body["lat"] = 10.850516;
        // body["lon"] = 76.27108;
        axios({
          method: "POST",
          url: "user/userregister",
          data: {
            username: this.uname,
            password: this.password,
            email: this.email,
            phone: this.phno,
            name: this.name,
            organization: this.organisation,
            occupation: this.occupations,
            state: this.state,
            gender: this.genders,
            lat:this.lat,
            lon:this.lon,
            // body: this.body,
          },
        })
          .then((response) => {
            if (response.data.status) {
              this.msg="Successfully Registred"
              this.showsnackbar = true;
              if(response.data.id)
               this.$router.push("/verify?verify="+ response.data.id);
              console.log(response);
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.ServerError=true;
          });
      }
    },
  },
};
</script>